<template>
  <main>
    <BackAndForth>
      <h1 v-html='kql.page.title' />
    </BackAndForth>
    <nav class="articles">
      <router-link :to="pathName(article.url)" v-for="article in children" :key="article.url">
        <time>{{ article.content.date }}</time>
        <h3>{{ article.title }}</h3>
        <div>{{ article.content.intro }}</div>
      </router-link>
    </nav>
  </main>
</template>

<script setup>
import { pageFromPath, pathName } from '@/utils'
import { useStore } from '@/KQL.js'
const kql = useStore();
const children = computed(()=>pageFromPath(kql.page.uid, kql?.pages)?.children);
</script>

<style scoped>
@import '@/css/breakpoints.css';

main {
  padding-top: var(--top-padding);
  margin: auto 2rem;
}

h1 {
  margin-left: 2rem;
}

a {
  display: flex;
}

h3 {
  font-family: Kessler;
  font-style: Italic;
  max-width: 12em;
  line-height: 1.2em;
  text-align: right;
}

nav.articles {
  margin-top: 6rem;
}

@media (--wide) {
  nav.articles {
    margin-left: 3rem;
    border-left: 1px solid var(--dark);
    padding-left: 1rem;
  }
}

time {
  font-size: var(--normal);
}

a div {
  max-width: 27em;
  line-height: 1.35em;
  text-align: left;
  font-size: var(--normal);
  margin-left: 2rem;
  margin-top: 0.75rem;
}


</style>
